"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domReadyPromise = exports.default = exports.DOM_READY = void 0;
const DOM_READY = exports.DOM_READY = 'DOMContentLoaded';
const domReadyPromise = async () => new Promise(resolve => {
  // Prevent failure on the server
  if (typeof document === 'undefined') {
    resolve(false);
  }
  if (document.readyState === 'loading') {
    const onReady = () => {
      document.removeEventListener(DOM_READY, onReady);
      resolve(true);
    };
    document.addEventListener(DOM_READY, onReady);
  } else {
    setTimeout(() => resolve(true));
  }
});
exports.domReadyPromise = domReadyPromise;
var _default = exports.default = domReadyPromise;